import {Box,Paper,Grid2, Container, Typography,IconButton,Button, Divider} from '@mui/material'
import Appbar from './Appbar'
import React, { Component } from 'react'
import base_url from './base_url'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate,useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ToastContainer, toast } from "react-toastify";



export class WishList extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       wishList  :[]
    }
  }


componentDidMount(){
  this.retriveWishList();
}


  retriveWishList=()=>{
    /// retrive wish list details
    let email = localStorage.getItem('email');

    if(email!==null){
    fetch(
      `${base_url.base_url}/wishList/retriveWishList`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body : JSON.stringify({
          email  : email
        })
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        
        this.setState({
         wishList : result.data
        },()=>{
          sessionStorage.setItem('wishListCount', result.data.length)
        });
      });

    }
  }


  addItemInCartList = async (product_id) => {
    let email = await localStorage.getItem("email");
    if (product_id !== "" && email !== null) {
      fetch(`${base_url.base_url}/cartList/addItemsInCart`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          email: email,
          product_id: product_id,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if (result.status) {
            this.Sucessfull();
            this.removeItemFromWishList(product_id)
          } else {
            this.Fail();
          }
        });
    } else {
      alert("Required Login");
    }
  };




   removeItemFromWishList=async(product_id)=>{
    let email = await localStorage.getItem("email");
    if (product_id !== "" && email !== null) {
      fetch(`${base_url.base_url}/wishList/removeItemsInWish`, {
        headers: {
          "content-type": "application/json",
        },
        method: "delete",
        body: JSON.stringify({
          email: email,
          product_id: product_id,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if (result.status) {
            this.removeFromWish();
            this.retriveWishList();
          }
        });
    } else {
      alert("Required Login");
    }
   }



 removeFromWish = () => {
    toast.success("Item removed from wishList ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };



  Sucessfull = () => {
    toast.success("Item added to cart list", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  Fail = () => {
    toast.error("Item already exists in cartList", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      //transition: Bounce,
    });
  };



  render() {
    const sum = this.state.wishList.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (
      <div>
<Box sx={{backgroundColor:'#e9edee'}}>
<Appbar/>
<br/>
<br/>
<br/>

<Container maxWidth='xl'>

<Grid2 container spacing={2}>
<Grid2 item size={{xs:12,sm:9}}>
<Box>


<Paper variant='outlined' sx={{minHeight:60,width:'100%',display:'flex',justifyContent:'center',flexDirection:'column',mb:1}}>

<Typography sx={{fontSize:15,fontWeight:'600',color:'black',pl:2,textTransform:'uppercase'}}>YOUR WISHED PRODUCTS LIST</Typography>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black',pl:2}}>You have saved item below for buying products.</Typography>

</Paper>



<Grid2 container spacing={2}>
{this.state.wishList.map((i)=>(
 <Grid2 item size={{xs:12,sm:6,md:3}}>
<Paper variant='outlined' sx={{width:'100%',minHeight:200}}>
<img src={`${base_url.base}` + "/" + `${i.thumb_nail_img}`} style={{height:220,width:'100%'}}/>
<Divider/>
<Box sx={{width:'100%',height:70,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'left'}}>

<Typography sx={{fontSize:12,fontWeight:'600' ,textTransform:'uppercase',color:'#c11778',ml:1,textAlign:'left'}}>{i.product_name}</Typography>
<Box sx={{display:'flex',justifyContent:'space-between',mt:1}}>
<Typography sx={{fontSize:14,fontWeight:'600' ,textTransform:'uppercase',color:'#1b7bce',ml:1,mt:0.5}}>{i.price}</Typography>
<Box sx={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
<Button  size='small' variant='outlined' disableElevation sx={{textTransform:'none',fontSize:13,ml:1,height:26}} onClick={this.removeItemFromWishList.bind(this,i.product_id)}>Remove</Button>
<Button  size='small' variant='contained' disableElevation sx={{textTransform:'none',fontSize:13,ml:1,mr:1,height:26}} onClick={this.addItemInCartList.bind(this,i.product_id)}>Add Cart</Button>
</Box>
</Box>
</Box>  
</Paper>
</Grid2> 
))

}



</Grid2>



</Box>
</Grid2>
<Grid2 item size={{xs:12,sm:3}}>
<Box>
<Paper variant='outlined' sx={{minHeight:140,width:'100%'}}>

<Typography textAlign='center' sx={{fontSize:18,fontWeight:'700',mt:2}}>Useable ({this.state.wishList.length} Items): {sum}</Typography>

<Box sx={{display:'flex',justifyContent:'center',alignItems:'center',mt:2}}>
  <Button onClick={()=>this.props.navigate('/cartList')} variant='contained' disableElevation size='small' sx={{height:25,p:2, textTransform:'none',width:'80%',backgroundColor:'#ab266c'}}>CHECK OUT</Button>
</Box>

{
    //// right section list
}






</Paper>
</Box>
</Grid2>

</Grid2>



</Container>
<br/>
</Box>


<ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          //transition={Bounce}
        />
      </div>
    )
  }
}

export default WishList


export function WishListc(props){
  const navigate = useNavigate();
  const location = useLocation();
  return (<WishList navigate={navigate}></WishList>)
}
